/* ==========================================================================
   Merch Studio — kurumsal merch konfigüratörü
   --------------------------------------------------------------------------
   Sayfadaki tüm merch-studio-* section'larını tek bir state üzerinden yönetir.
   Section'lar birbirinden bağımsız kalır (customizer'da ayrı ayrı düzenlenebilsin
   diye); bağlanma tamamen data attribute sözleşmesi üzerinden yapılır:

     [data-ms-view="hero design"]   -> bu görünümlerde görünür olan section/eleman
     [data-ms-go="quantity"]        -> tıklanınca o görünüme geçiren buton
     [data-ms-field="title"]        -> aktif üründen doldurulan metin alanı
     [data-ms-catalog]              -> Liquid'in bastığı JSON veri paketi

   Sayfa hiçbir adımda yenilenmez; renk değişimi bile ürün değiştirdiği halde
   kişiselleştirme ve adet state'ini korur.
   ========================================================================== */

(function () {
  'use strict';

  var VIEWS = ['hero', 'design', 'quantity', 'quote', 'done'];
  var STEP_VIEWS = ['design', 'quantity', 'quote'];

  /* Logo dosyası bu eşiğin altındaysa teklif payload'ına base64 olarak gömülür.
     Üstündeyse ayrı bir yükleme ucu gerekir (bkz. config.uploadWebhook). Ayrı uç
     tanımlı değilse kullanıcıya dosyayı e-posta ile isteyeceğimiz söylenir. */
  var INLINE_UPLOAD_MAX = 1.5 * 1024 * 1024;

  // Çeviriler theme'den window.msStrings'e basılıyor. Section hiç render edilmediyse
  // (ör. sadece hero varsa) tanımsız kalmasın diye burada garantiye alıyoruz.
  window.msStrings = window.msStrings || {};

  var $ = function (sel, root) { return (root || document).querySelector(sel); };
  var $$ = function (sel, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  };

  var round2 = function (n) { return Math.round(n * 100) / 100; };

  /* ---------------------------------------------------------------- para */

  var trNumber = new Intl.NumberFormat('tr-TR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });

  function money(n) {
    if (typeof n !== 'number' || !isFinite(n)) return '—';
    return trNumber.format(n) + ' ₺';
  }

  function usdMoney(n) {
    if (typeof n !== 'number' || !isFinite(n)) return '—';
    return '$' + n.toFixed(2);
  }

  /* -------------------------------------------------------- fiyat motoru */

  /**
   * Kademe tablosundaki kırılım noktaları arasında doğrusal ara değer.
   * Excel'deki 984 satır, düzine kırılımlarında 4 banttan oluşan parçalı doğrusal
   * bir eğri — 8 kırılım noktası tabloyu birim başına 0.00008 USD sapmayla üretir.
   */
  function unitUsd(ladder, qty) {
    if (!ladder || !ladder.anchors || !ladder.anchors.length) return null;
    var a = ladder.anchors;
    var min = typeof ladder.min === 'number' ? ladder.min : a[0][0];
    var max = typeof ladder.max === 'number' ? ladder.max : a[a.length - 1][0];
    var q = Math.min(Math.max(qty, min), max);

    if (q <= a[0][0]) return a[0][1];
    for (var i = 1; i < a.length; i++) {
      if (q <= a[i][0]) {
        var q0 = a[i - 1][0], p0 = a[i - 1][1];
        var q1 = a[i][0], p1 = a[i][1];
        if (q1 === q0) return p1;
        return p0 + (p1 - p0) * (q - q0) / (q1 - q0);
      }
    }
    return a[a.length - 1][1];
  }

  /**
   * Yuvarlama ÖNCE birim fiyatta yapılıyor, sonra adetle çarpılıyor.
   * Böylece ekranda gösterilen "birim x adet" müşteri hesap makinesiyle kontrol
   * ettiğinde toplamı birebir tutuyor. Ters sırada 650 adette ~2 TL'lik
   * "olmayan kuruş" farkı çıkıyor.
   *
   * KDV kademenin `vat` alanında (yüzde); kademedeki USD KDV hariç. İfade
   * merch-price.js ve n8n ile BİREBİR aynı olmalı — bkz. oradaki açıklama.
   */
  function priceFor(ladder, fxRate, qty) {
    var usd = unitUsd(ladder, qty);
    if (usd === null) return null;
    var vat = ladder && typeof ladder.vat === 'number' ? ladder.vat : 0;
    var unitTry = round2(usd * fxRate * (1 + vat / 100));
    return {
      unitUsd: usd,
      unitUsdGross: usd * (1 + vat / 100),
      unitTry: unitTry,
      total: round2(unitTry * qty),
      clampedHigh: qty > (typeof ladder.max === 'number' ? ladder.max : 999)
    };
  }

  /* ------------------------------------------------------- metin ölçümü */

  var _measureCtx = null;
  function measureCtx() {
    if (!_measureCtx) {
      _measureCtx = document.createElement('canvas').getContext('2d');
    }
    return _measureCtx;
  }

  /**
   * Yazıyı baskı alanının genişliğine tam oturtan font boyutu.
   * SVG textLength ile germek kısa metinleri deforme ediyor; canvas ile ölçüp
   * ölçeklemek hem doğru hem ucuz. Tek harfin devasa büyümemesi için tavan var.
   */
  function fitFontSize(text, family, weight, boxWidthPx) {
    if (!text || !boxWidthPx) return 0;
    var ctx = measureCtx();
    ctx.font = weight + ' 100px ' + family;
    var w = ctx.measureText(text).width;
    if (!w) return 0;
    return Math.min((boxWidthPx / w) * 100, boxWidthPx * 0.45);
  }

  /* --------------------------------------------------------- SVG şablon */

  var TEE = {
    front: {
      body: 'M96 84 L138 60 Q180 96 222 60 L264 84 L296 126 L262 156 L252 146 L252 300 Q180 314 108 300 L108 146 L98 156 L64 126 Z',
      collar: 'M138 60 Q180 96 222 60'
    },
    back: {
      body: 'M96 84 L138 60 Q180 72 222 60 L264 84 L296 126 L262 156 L252 146 L252 300 Q180 314 108 300 L108 146 L98 156 L64 126 Z',
      collar: 'M142 62 Q180 78 218 62'
    }
  };

  function teeSvg(side, hex) {
    var t = TEE[side] || TEE.front;
    var isWhite = String(hex).toLowerCase() === '#ffffff' || String(hex).toLowerCase() === '#fff';
    var stroke = isWhite ? '#d9d6cf' : 'rgba(0,0,0,.25)';
    return '<svg class="ms-stage__svg" viewBox="0 0 360 360" role="img" aria-hidden="true">' +
      '<path d="' + t.body + '" fill="' + hex + '" stroke="' + stroke + '" stroke-width="1.5"/>' +
      '<path d="' + t.collar + '" fill="none" stroke="' + stroke + '" stroke-width="1.5"/>' +
      '</svg>';
  }

  /* =========================================================== controller */

  function MerchStudio(root) {
    this.root = root || document;
    this.catalog = null;
    this.products = [];
    this.state = {
      view: 'hero',
      productId: null,
      side: 'front',
      perso: false,
      decorations: [],
      active: 0,
      qty: {},          // beden etiketine göre — renk değişince adetler korunsun diye
      submitting: false,
      requestNo: null
    };
    this._stockChecked = {};
  }

  MerchStudio.prototype.init = function () {
    var node = $('[data-ms-catalog]');
    if (!node) {
      // Sessizce çıkmak hata ayıklamayı zorlaştırıyordu: bu durumda hiçbir buton
      // çalışmaz, çünkü olay dinleyicileri de bağlanmaz.
      var reasons = {
        no_product: 'Bölümde ürün seçilmemiş VEYA seçilen ürün Online Store satış ' +
                    'kanalına yayınlanmamış (Liquid ikisini ayırt edemiyor).',
        no_model: 'Ürüne merch.model metaobject referansı bağlanmamış.',
        gated: 'Erişim ayarı bu ziyaretçiyi dışarıda bırakıyor.'
      };
      var errEl = $('[data-ms-setup-error]');
      if (errEl) {
        var key = errEl.getAttribute('data-ms-setup-error');
        console.error('[merch-studio] Konfigüratör başlamadı — sebep: ' + (reasons[key] || key));
      } else {
        // Bölüm ne katalog ne de hata işareti basmış: bölüm sayfada hiç yok ya da
        // sunucudan eski/önbellekli bir kopya geliyor demektir.
        console.error(
          '[merch-studio] Katalog verisi de kurulum hata işareti de sayfada yok. ' +
          '"Merch Studio · 1 Tasarla" bölümü bu sayfada hiç render edilmemiş olabilir; ' +
          'sayfa kaynağında (Ctrl+U) "data-ms-catalog" ve "data-ms-setup-error" arayın.'
        );
      }
      return false;
    }

    try {
      this.catalog = JSON.parse(node.textContent);
    } catch (e) {
      console.error('[merch-studio] katalog JSON çözümlenemedi', e);
      return false;
    }

    this.products = (this.catalog.products || []).filter(Boolean);
    if (!this.products.length) {
      console.warn('[merch-studio] katalogda ürün yok');
      return false;
    }

    // Hex'i çözülemeyen renkler gri swatch olarak çıkıyor. Hangisi olduğunu gözle
    // ayırt etmek zor (bazı gerçek renkler de açık gri), o yüzden konsola isim isim
    // yazıp Color swatch ayarına eklenecek satırları hazır veriyoruz.
    var unresolved = this.products.filter(function (p) { return p.colorResolved === false; });
    if (unresolved.length) {
      console.warn(
        '[merch-studio] ' + unresolved.length + ' rengin hex\'i okunamadı, ' +
        'gri (#cccccc) gösteriliyor:\n' +
        unresolved.map(function (p) {
          var name = p.colorRaw || '';
          if (!name) {
            return '  • ' + p.title + ' → product.color metafield\'ı BOŞ';
          }
          if (p.colorHexRaw) {
            return '  • ' + name + ' → hex değeri geçersiz: "' + p.colorHexRaw + '"';
          }
          return '  • ' + name + ' → Configuration\'da tanımlı değil, ekleyin: ' +
                 name + '::#______;';
        }).join('\n') +
        // Tema ayarı ile ekrandaki arasında uyuşmazlık olduğunda (önbellek, senkron
        // gecikmesi) hangisinin geride kaldığını tahmin etmeden görebilmek için
        '\nTemanın bu render\'da okuduğu Color swatch: ' + this.catalog.config.swatchCount +
        ' tanım, sonuncusu "' + this.catalog.config.swatchLast + '"'
      );
    }

    // Tekrar eden tanım artık swatch'ı bozmuyor (ilk eşleşme alınıyor) ama
    // Configuration'ı temizlemek gerekiyor: hangi hex'in kazandığı sıraya bağlı kalır.
    var duped = this.products.filter(function (p) { return p.colorMatches > 1; });
    if (duped.length) {
      console.warn(
        '[merch-studio] ' + duped.length + ' renk Color swatch Configuration\'da ' +
        'birden fazla kez tanımlı. İlk tanım kullanılıyor, ama fazlalıkları silin ' +
        '(başında/sonunda boşluk olan kopyalara dikkat):\n' +
        duped.map(function (p) {
          return '  • ' + p.colorRaw + ' → ' + p.colorMatches + ' kez';
        }).join('\n')
      );
    }

    // ?p=<handle> giriş ürününü ezer — normal PDP'den gelen link ve renk
    // değişiminde yazılan URL bu parametreyi kullanıyor.
    var wanted = new URLSearchParams(window.location.search).get('p');
    var byHandle = wanted && this.findByHandle(wanted);
    if (wanted && !byHandle) {
      // Handle katalogda yok: ya yanlış yazılmış ya da o renk Online Store'a
      // yayınlanmadığı için product.list'ten çözülememiş. Giriş ürününe düşüyoruz.
      console.warn(
        '[merch-studio] ?p=' + wanted + ' katalogda bulunamadı, giriş ürünü kullanılıyor. ' +
        'Katalogdaki handle\'lar: ' + this.products.map(function (p) { return p.handle; }).join(', ')
      );
    }
    this.state.productId = byHandle ? byHandle.id : this.catalog.entry;
    if (!this.product()) this.state.productId = this.products[0].id;

    this.state.decorations = [this.newDecoration()];
    this.bind();
    this.renderAll();
    this.go(this.state.view, { scroll: false });
    return true;
  };

  /* ------------------------------------------------------------ yardımcı */

  MerchStudio.prototype.product = function () {
    return this.findById(this.state.productId);
  };

  MerchStudio.prototype.findById = function (id) {
    for (var i = 0; i < this.products.length; i++) {
      if (this.products[i].id === id) return this.products[i];
    }
    return null;
  };

  MerchStudio.prototype.findByHandle = function (handle) {
    for (var i = 0; i < this.products.length; i++) {
      if (this.products[i].handle === handle) return this.products[i];
    }
    return null;
  };

  MerchStudio.prototype.ladder = function () {
    return (this.catalog.shared && this.catalog.shared.priceLadder) || null;
  };

  /*
   * Minimum sipariş adedi iki ayrı şey olabilir:
   *   customization.minimum_quantity — ticari kural ("50 adetten az üretmiyoruz")
   *   ladder.min                     — fiyat tablosunun alt sınırı
   * Tabloda olmayan bir adede fiyat veremeyeceğimiz için büyük olan geçerli.
   */
  MerchStudio.prototype.moq = function () {
    var ladder = this.ladder() || {};
    return Math.max(this.catalog.config.moq || 0, ladder.min || 0) || 1;
  };

  // Baskı alanları da modele ait — renk değişince yer değiştirmiyorlar.
  MerchStudio.prototype.printAreas = function () {
    return (this.catalog.shared && this.catalog.shared.printAreas) ||
      this.catalog.config.defaultPrintAreas;
  };

  /**
   * Arka görünüm ne zaman var?
   *  - Ürünün arka mockup'ı tanımlıysa: evet.
   *  - Ürünün hiç fotoğrafı yoksa: evet — iki yüz de SVG şablondan çizilir, tutarlı.
   *  - Ön fotoğraf var ama arka yok: HAYIR. Aksi halde ÖN'de fotoğraf, ARKA'da çizim
   *    görünür; bu bozuk bir ürün izlenimi veriyor.
   */
  MerchStudio.prototype.hasBackView = function () {
    var p = this.product();
    if (!p) return false;
    var m = p.mockups || {};
    return !!m.back || !m.front;
  };

  MerchStudio.prototype.allAreas = function () {
    var pa = this.printAreas() || {};
    var out = [];
    // Arka görünüm yoksa sırt konumları da listelenmiyor — seçilse önizlenemezdi
    var sides = this.hasBackView() ? ['front', 'back'] : ['front'];
    sides.forEach(function (side) {
      var group = pa[side];
      if (!group || !group.areas) return;
      group.areas.forEach(function (area) {
        out.push({ side: side, area: area });
      });
    });
    return out;
  };

  MerchStudio.prototype.areaById = function (id) {
    var all = this.allAreas();
    for (var i = 0; i < all.length; i++) {
      if (all[i].area.id === id) return all[i];
    }
    return all[0] || null;
  };

  MerchStudio.prototype.newDecoration = function () {
    var first = this.allAreas()[0];
    var cfg = this.catalog.config;
    return {
      placement: first ? first.area.id : 'frontMid',
      content: 'logo',
      logo: null,          // { name, type, size, dataUrl }
      text: '',
      font: cfg.fonts[0].id,
      ink: 'auto',        // 'auto' = ürün rengine göre siyah/beyaz
      size: cfg.decorSizes[1] ? cfg.decorSizes[1].id : cfg.decorSizes[0].id
    };
  };

  MerchStudio.prototype.decoration = function () {
    return this.state.decorations[this.state.active];
  };

  /* Beden sırası: merch.size_order -> yoksa variant sırası */
  MerchStudio.prototype.sizes = function () {
    var p = this.product();
    if (!p) return [];
    var variants = p.variants || [];
    var order = (this.catalog.shared && this.catalog.shared.sizeOrder) || [];
    if (!order.length) return variants.slice();

    var out = [];
    order.forEach(function (label) {
      var norm = String(label).trim().toLowerCase();
      variants.forEach(function (v) {
        if (String(v.size).trim().toLowerCase() === norm) out.push(v);
      });
    });
    // Sıralamada adı geçmeyen variantlar kaybolmasın
    variants.forEach(function (v) {
      if (out.indexOf(v) === -1) out.push(v);
    });
    return out;
  };

  MerchStudio.prototype.variantBySize = function (size) {
    var vs = this.sizes();
    for (var i = 0; i < vs.length; i++) {
      if (vs[i].size === size) return vs[i];
    }
    return null;
  };

  MerchStudio.prototype.totalUnits = function () {
    var qty = this.state.qty, sum = 0;
    this.sizes().forEach(function (v) {
      sum += qty[v.size] || 0;
    });
    return sum;
  };

  /**
   * Bu renkte toplam kaç adet satılabilir.
   * MOQ toplam siparişe ait olduğu için tek bedenin stoğu MOQ'nun altında olabilir —
   * 30 XS + 20 M = 50 geçerli bir sipariş. Anlamlı olan kontrol, tüm bedenlerin
   * toplamının MOQ'ya yetip yetmediği. Stok takibi kapalı tek variant varsa sınırsız.
   */
  MerchStudio.prototype.totalCap = function () {
    if (!this.catalog.config.enforceStock) return Infinity;
    var sizes = this.sizes();
    var sum = 0;
    for (var i = 0; i < sizes.length; i++) {
      if (typeof sizes[i].cap !== 'number') return Infinity;
      sum += sizes[i].cap;
    }
    return sum;
  };

  MerchStudio.prototype.overCapSizes = function () {
    if (!this.catalog.config.enforceStock) return [];
    var qty = this.state.qty, bad = [];
    this.sizes().forEach(function (v) {
      if (typeof v.cap === 'number' && (qty[v.size] || 0) > v.cap) bad.push(v);
    });
    return bad;
  };

  MerchStudio.prototype.quote = function () {
    var total = this.totalUnits();
    var cfg = this.catalog.config;
    if (!total) return { units: 0, tierQty: 0, unitUsd: null, unitTry: null, total: 0 };

    var ladder = this.ladder() || {};
    var p = priceFor(ladder, cfg.fx.rate, total);
    if (!p) return { units: total, tierQty: total, unitUsd: null, unitTry: null, total: 0 };

    /*
     * tierQty: fiyatın GERÇEKTEN okunduğu adet. MOQ altında tablo alt sınıra
     * kırpıldığı için girilen adetten farklı olabiliyor; etikette girilen adedi
     * yazmak "30 adet kademesi" deyip 50 adedin fiyatını göstermek olurdu.
     */
    var lmin = typeof ladder.min === 'number' ? ladder.min : cfg.moq;
    var lmax = typeof ladder.max === 'number' ? ladder.max : cfg.qmax;

    return {
      units: total,
      tierQty: Math.min(Math.max(total, lmin), lmax),
      unitUsd: p.unitUsd,
      unitUsdGross: p.unitUsdGross,
      unitTry: p.unitTry,
      total: p.total,
      clampedHigh: p.clampedHigh
    };
  };

  /* ------------------------------------------------------------ yönlendirme */

  MerchStudio.prototype.go = function (view, opts) {
    opts = opts || {};
    if (VIEWS.indexOf(view) === -1) return;

    // Henüz kurulmamış bir adıma (ör. quote section'ı eklenmemişse) düşmeyelim
    if (!$('[data-ms-view~="' + view + '"]')) {
      console.warn('[merch-studio] "' + view + '" görünümü sayfada yok');
      return;
    }

    this.state.view = view;

    $$('[data-ms-view]').forEach(function (el) {
      var list = el.getAttribute('data-ms-view').split(/\s+/);
      el.classList.toggle('ms-hidden', list.indexOf(view) === -1);
    });

    $$('[data-ms-step]').forEach(function (el) {
      var step = el.getAttribute('data-ms-step');
      el.classList.toggle('is-active', step === view);
      el.classList.toggle('is-done', STEP_VIEWS.indexOf(step) < STEP_VIEWS.indexOf(view));
    });

    if (view === 'quantity') {
      this.refreshStock();
      this.renderQty();
    }
    if (view === 'quote') this.renderSummary();

    if (opts.scroll !== false) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  /* --------------------------------------------------------------- render */

  MerchStudio.prototype.renderAll = function () {
    this.renderProductFields();
    this.renderSwatches();
    this.renderPlacements();
    this.renderFonts();
    this.renderInks();
    this.renderDecorSizes();
    this.renderDecList();
    this.renderEditor();
    this.renderStages();
    this.renderQty();
  };

  MerchStudio.prototype.renderProductFields = function () {
    var p = this.product();
    if (!p) return;
    var self = this;
    var shared = this.catalog.shared || {};
    var cfg = this.catalog.config;

    // specLine ve priceNote modele ait (renge göre değişmiyor), bu yüzden shared'da.
    var fields = {
      title: p.title,
      specLine: shared.specLine || '',
      colorName: p.colorName || '',
      priceNote: shared.priceNote || ''
    };

    /*
     * Başlangıç fiyatı iki kaynaktan gelebilir:
     *   'product' — Shopify ürün fiyatı (varsayılan). Tek adet perakende fiyatı; toplu
     *               alımda Adım 2'de kademe tablosuna göre DÜŞER, "başlayan fiyatlarla"
     *               ifadesi bunu anlatır.
     *   'ladder'  — kademe tablosundan minimum adette hesaplanır. İki ekranda birebir
     *               aynı sayıyı göstermek istendiğinde kullanılır.
     * Ürüne merch.unit_price_override girilmişse ikisini de ezer.
     */
    var ladder = this.ladder();
    var startPrice;
    if (p.unitPriceOverride != null) {
      startPrice = p.unitPriceOverride;
    } else if (cfg.priceSource === 'ladder') {
      var start = priceFor(ladder, cfg.fx.rate, this.moq());
      startPrice = start ? start.unitTry : p.shopifyPrice;
    } else {
      startPrice = p.shopifyPrice;
    }
    fields.unitPrice = money(startPrice);

    $$('[data-ms-field]').forEach(function (el) {
      var key = el.getAttribute('data-ms-field');
      if (fields[key] === undefined) return;

      // Ürün metafield'ı doluysa o kazanır; boşsa section'daki varsayılan metin
      // korunur (ör. price_note girilmemiş ürünlerde "başlayan fiyatlarla").
      var value = String(fields[key]).trim();
      if (!value && el.hasAttribute('data-ms-default')) {
        value = el.getAttribute('data-ms-default');
      }
      el.textContent = value;

      // İçeriği tamamen boş kalan alanı gizle — aksi halde boş bir satır yer kaplıyor
      var wrap = el.closest('[data-ms-field-wrap]') || el;
      wrap.classList.toggle('ms-hidden', !value);
    });

    $$('[data-ms-breadcrumb-product]').forEach(function (el) {
      el.textContent = p.title;
    });

    var ratingWrap = $('[data-ms-rating]');
    if (ratingWrap) {
      if (p.rating && p.rating.value) {
        ratingWrap.classList.remove('ms-hidden');
        var rv = $('[data-ms-rating-value]', ratingWrap);
        var rc = $('[data-ms-rating-count]', ratingWrap);
        if (rv) rv.textContent = Number(p.rating.value).toFixed(2);
        if (rc) rc.textContent = p.rating.count;
      } else {
        ratingWrap.classList.add('ms-hidden');
      }
    }

    $$('[data-ms-swatches] [data-ms-swatch]').forEach(function (el) {
      el.classList.toggle('is-active', Number(el.getAttribute('data-ms-swatch')) === self.state.productId);
    });
  };

  MerchStudio.prototype.renderSwatches = function () {
    var box = $('[data-ms-swatches]');
    if (!box) return;
    var self = this;
    box.innerHTML = '';

    this.products.forEach(function (p) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'ms-swatch';
      btn.setAttribute('data-ms-swatch', p.id);
      btn.setAttribute('aria-label', p.colorName);
      btn.title = p.colorName;
      if (p.id === self.state.productId) btn.classList.add('is-active');

      var dot = document.createElement('span');
      dot.className = 'ms-swatch__dot';
      dot.style.backgroundColor = p.colorHex;
      btn.appendChild(dot);

      btn.addEventListener('click', function () { self.selectProduct(p.id); });
      box.appendChild(btn);
    });
  };

  /**
   * Renk seçimi = ürün değişimi, ama sayfa yenilenmeden.
   * Kişiselleştirme ve adet state'i korunur; adetler beden etiketiyle saklandığı
   * için yeni ürünün variantlarına kendiliğinden oturur.
   */
  MerchStudio.prototype.selectProduct = function (id) {
    if (id === this.state.productId) return;
    var p = this.findById(id);
    if (!p) return;

    this.state.productId = id;

    // Baskı alanları modele ait ama arka görseli olmayan renkte sırt konumları
    // listelenmiyor; o renge geçilince sırt dekoru geçersiz kalır, öne alıyoruz.
    var valid = {};
    this.allAreas().forEach(function (a) { valid[a.area.id] = true; });
    var fallback = this.allAreas()[0];
    this.state.decorations.forEach(function (d) {
      if (!valid[d.placement] && fallback) d.placement = fallback.area.id;
    });

    var url = new URL(window.location.href);
    url.searchParams.set('p', p.handle);
    window.history.replaceState({}, '', url.toString());

    this._stockChecked[p.handle] = false;
    this.renderProductFields();
    this.renderPlacements();
    this.renderDecList();
    this.renderEditor();
    this.renderStages();
    this.renderQty();
    if (this.state.view === 'quantity') this.refreshStock();
  };

  /* --------------------------------------------------------------- önizleme */

  MerchStudio.prototype.renderStages = function () {
    var self = this;
    var hasBack = this.hasBackView();

    // Arka görseli tanımlanmamış üründe Ön/Arka anahtarı hiç gösterilmiyor
    if (!hasBack && this.state.side === 'back') this.state.side = 'front';
    $$('[data-ms-side-toggle]').forEach(function (el) {
      el.classList.toggle('ms-hidden', !hasBack);
    });

    $$('[data-ms-stage]').forEach(function (stage) { self.paintStage(stage); });
    $$('[data-ms-side]').forEach(function (btn) {
      btn.classList.toggle('is-active', btn.getAttribute('data-ms-side') === self.state.side);
    });
  };

  MerchStudio.prototype.paintStage = function (stage) {
    var p = this.product();
    if (!p) return;

    // Adet adımındaki önizleme her zaman ön yüzü gösteriyor; tasarım adımı
    // kullanıcının seçtiği yüzü izliyor.
    var side = stage.hasAttribute('data-ms-stage-fixed-front') ? 'front' : this.state.side;

    var frame = $('[data-ms-stage-frame]', stage) || stage;
    var media = $('[data-ms-stage-media]', stage);
    var art = $('[data-ms-stage-art]', stage);
    if (!media || !art) return;

    var self = this;
    var src = p.mockups && p.mockups[side];

    if (src) {
      var img = media.querySelector('img');
      if (!img) {
        media.innerHTML = '';
        img = document.createElement('img');
        img.className = 'ms-stage__img';
        media.appendChild(img);
      }

      // Sahnenin oranını görselin gerçek oranına eşitle: görsel kutuyu tam kaplar,
      // baskı katmanı da onunla örtüşür. Yüklenmeyi beklemek gerekiyor; önbellekten
      // gelen görselde load olayı tetiklenmediği için complete kontrolü de var.
      var applyRatio = function () {
        if (!img.naturalWidth || !img.naturalHeight) return;
        stage.style.setProperty(
          '--ms-stage-ratio', img.naturalWidth + ' / ' + img.naturalHeight
        );
        // Oran değişince kutu boyutu değişir; yazı boyutu piksel hesaplı, yeniden çiz
        self.paintArt(frame, art, side);
      };
      img.onload = applyRatio;

      if (img.getAttribute('src') !== src) img.setAttribute('src', src);
      img.setAttribute('alt', p.title + ' — ' + p.colorName);
      if (img.complete) applyRatio();
    } else {
      // Fotoğrafı olmayan ürün SVG şablona düşer, sistem eksik veriyle de çalışır.
      // SVG viewBox 360x360 olduğu için sahne de kare olmalı, yoksa baskı alanı kayar.
      media.innerHTML = teeSvg(side, p.colorHex);
      stage.style.setProperty('--ms-stage-ratio', '1');
    }

    this.paintArt(frame, art, side);
  };

  /** frame: baskı katmanının hizalandığı kutu — görselin gerçek alanı */
  MerchStudio.prototype.paintArt = function (frame, art, side) {
    art.innerHTML = '';
    if (!this.state.perso) return;

    var self = this;
    var cfg = this.catalog.config;
    var stageWidth = frame.clientWidth || 0;

    /*
     * Ürün başına baskı düzeltmesi. Baskı alanları modele ait ama fotoğrafların
     * çerçevelenmesi renkten renge değişiyor (gömlek kiminde daha büyük, kiminde
     * kaymış). Alanların gömlek üzerindeki yeri aynı olduğu için her ürüne ayrı
     * alan seti tanımlamak yerine merkez etrafında ölçek + kaydırma uyguluyoruz.
     */
    var off = (this.product() || {}).printOffset || {};
    var oScale = typeof off.scale === 'number' ? off.scale : 1;
    var oDx = typeof off.dx === 'number' ? off.dx : 0;
    var oDy = typeof off.dy === 'number' ? off.dy : 0;

    this.state.decorations.forEach(function (d) {
      var found = self.areaById(d.placement);
      if (!found || found.side !== side) return;

      var area = found.area;
      var scale = 1;
      cfg.decorSizes.forEach(function (s) { if (s.id === d.size) scale = s.scale; });

      var cx = 0.5 + (area.x - 0.5) * oScale + oDx;
      var cy = 0.5 + (area.y - 0.5) * oScale + oDy;

      var box = document.createElement('div');
      box.className = 'ms-art';
      box.style.left = (cx * 100) + '%';
      box.style.top = (cy * 100) + '%';
      box.style.width = (area.w * scale * oScale * 100) + '%';

      if (d.content === 'logo' && d.logo) {
        // Kare kutu sınıfı: oran ve object-fit CSS'te, taşma orada kesiliyor.
        box.classList.add('ms-art--logo');
        var img = document.createElement('img');
        img.className = 'ms-art__logo';
        img.src = d.logo.dataUrl;
        img.alt = '';
        box.appendChild(img);
      } else if (d.content === 'text' && d.text) {
        var font = cfg.fonts[0];
        cfg.fonts.forEach(function (f) { if (f.id === d.font) font = f; });

        var span = document.createElement('span');
        span.className = 'ms-art__text';
        span.textContent = d.text;
        span.style.fontFamily = font.family;
        span.style.fontWeight = font.weight;
        span.style.color = self.inkHexFor(d, self.product().colorHex);

        var boxPx = stageWidth * area.w * scale * oScale;
        var size = fitFontSize(d.text, font.family, font.weight, boxPx);
        if (size) span.style.fontSize = size + 'px';
        box.appendChild(span);
      } else {
        return;
      }

      art.appendChild(box);
    });
  };

  /** Koyu zeminde beyaz, açık zeminde siyah yazı — WCAG'ın relative luminance eşiği */
  MerchStudio.prototype.inkFor = function (hex) {
    var h = String(hex).replace('#', '');
    if (h.length === 3) h = h[0] + h[0] + h[1] + h[1] + h[2] + h[2];
    var r = parseInt(h.substr(0, 2), 16) / 255;
    var g = parseInt(h.substr(2, 2), 16) / 255;
    var b = parseInt(h.substr(4, 2), 16) / 255;
    if (isNaN(r) || isNaN(g) || isNaN(b)) return '#141414';
    var lin = function (c) { return c <= 0.03928 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4); };
    var L = 0.2126 * lin(r) + 0.7152 * lin(g) + 0.0722 * lin(b);
    return L > 0.4 ? '#141414' : '#ffffff';
  };

  /**
   * Dekorun yazı rengi.
   *
   * 'auto' (varsayılan) ürün rengine göre siyah ya da beyaz seçiyor. Müşteri
   * palet'ten bir renk seçtiyse o kazanıyor. Fallback rengi PARAMETRE:
   * canvas önizlemesi başka bir ürünün rengiyle çiziliyor olabilir.
   */
  MerchStudio.prototype.inkHexFor = function (d, colorHex) {
    var secili = null;
    var istenen = (d && d.ink) || 'auto';
    (this.catalog.config.inks || []).forEach(function (i) {
      if (i.id === istenen) secili = i;
    });
    if (secili && secili.hex) return secili.hex;
    return this.inkFor(colorHex);
  };

  /* ------------------------------------------------------- kişiselleştirme */

  MerchStudio.prototype.renderPlacements = function () {
    var box = $('[data-ms-placements]');
    if (!box) return;
    var self = this;
    var d = this.decoration();
    box.innerHTML = '';

    this.allAreas().forEach(function (item) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'ms-seg__btn';
      btn.textContent = item.area.label || item.area.id;
      if (d && d.placement === item.area.id) btn.classList.add('is-active');
      btn.addEventListener('click', function () {
        var dec = self.decoration();
        if (!dec) return;
        dec.placement = item.area.id;
        if (self.state.side !== item.side) self.state.side = item.side;
        self.renderPlacements();
        self.renderDecList();
        self.renderStages();
      });
      box.appendChild(btn);
    });
  };

  MerchStudio.prototype.renderFonts = function () {
    var box = $('[data-ms-fonts]');
    if (!box) return;
    var self = this;
    box.innerHTML = '';

    this.catalog.config.fonts.forEach(function (f) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'ms-font';
      var d = self.decoration();
      if (d && d.font === f.id) btn.classList.add('is-active');
      // Aile adı style="" içine STRING olarak gömülmüyor: merchant
      // 'Font::"Times New Roman", serif::400' gibi ÇİFT TIRNAKLI bir değer
      // yazarsa attribute erken kapanır, HTML kırılır ve font hiç uygulanmaz —
      // eklenen fontlar sessizce birbirinin aynısı görünürdü.
      var ornek = document.createElement('span');
      ornek.className = 'ms-font__sample';
      ornek.textContent = 'Aa';
      ornek.style.fontFamily = f.family;
      ornek.style.fontWeight = f.weight;

      var etiket = document.createElement('small');
      etiket.className = 'ms-font__label';
      etiket.textContent = f.label;

      btn.appendChild(ornek);
      btn.appendChild(etiket);
      // Tam aile hover'da: hangi yazı tipinin düştüğü merchant testinde belli olsun.
      btn.title = f.label + ' — ' + f.family;
      btn.addEventListener('click', function () {
        var dec = self.decoration();
        if (!dec) return;
        dec.font = f.id;
        self.renderFonts();
        self.renderStages();
      });
      box.appendChild(btn);
    });
  };

  /**
   * Yazı rengi seçici.
   *
   * "Otomatik" noktası ürünün O ANKİ rengine göre boyanıyor: müşteri seçmeden
   * önce ne olacağını görüyor. Palet tek seçenekten ibaretse (yalnızca
   * Otomatik) seçici hiç basılmıyor — tıklanacak tek şey sunmak gürültü.
   */
  MerchStudio.prototype.renderInks = function () {
    var box = $('[data-ms-inks]');
    if (!box) return;
    var self = this;
    var inks = this.catalog.config.inks || [];
    box.innerHTML = '';
    if (inks.length < 2) return;

    inks.forEach(function (ink) {
      var d = self.decoration();
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'ms-ink';
      btn.title = ink.label;
      btn.setAttribute('aria-label', ink.label);
      if (d && (d.ink || 'auto') === ink.id) btn.classList.add('is-active');

      var dot = document.createElement('span');
      dot.className = 'ms-ink__dot';
      dot.style.background = ink.hex || self.inkFor(self.product().colorHex);
      if (!ink.hex) dot.classList.add('is-auto');
      btn.appendChild(dot);

      btn.addEventListener('click', function () {
        var dec = self.decoration();
        if (!dec) return;
        dec.ink = ink.id;
        self.renderInks();
        self.renderStages();
      });

      box.appendChild(btn);
    });
  };

  MerchStudio.prototype.renderDecorSizes = function () {
    var box = $('[data-ms-decor-sizes]');
    if (!box) return;
    var self = this;
    box.innerHTML = '';

    this.catalog.config.decorSizes.forEach(function (s) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'ms-seg__btn';
      btn.textContent = s.label;
      var d = self.decoration();
      if (d && d.size === s.id) btn.classList.add('is-active');
      btn.addEventListener('click', function () {
        var dec = self.decoration();
        if (!dec) return;
        dec.size = s.id;
        self.renderDecorSizes();
        self.renderDecList();
        self.renderStages();
      });
      box.appendChild(btn);
    });
  };

  MerchStudio.prototype.decLabel = function (d) {
    var found = this.areaById(d.placement);
    var where = found ? (found.area.label || found.area.id) : '';
    var sizeLabel = '';
    this.catalog.config.decorSizes.forEach(function (s) { if (s.id === d.size) sizeLabel = s.label; });
    var what;
    if (d.content === 'logo') {
      what = d.logo ? d.logo.name : (window.msStrings.logoEmpty || 'Logo');
    } else {
      what = d.text ? ('“' + d.text + '”') : (window.msStrings.textEmpty || 'Metin');
    }
    return where + ' · ' + sizeLabel + ' · ' + what;
  };

  MerchStudio.prototype.renderDecList = function () {
    var box = $('[data-ms-dec-list]');
    if (!box) return;
    var self = this;
    box.innerHTML = '';

    this.state.decorations.forEach(function (d, i) {
      var chip = document.createElement('div');
      chip.className = 'ms-chip' + (i === self.state.active ? ' is-active' : '');

      var label = document.createElement('button');
      label.type = 'button';
      label.className = 'ms-chip__label';
      label.textContent = self.decLabel(d);
      label.addEventListener('click', function () {
        self.state.active = i;
        var found = self.areaById(d.placement);
        if (found) self.state.side = found.side;
        self.renderDecList();
        self.renderEditor();
        self.renderStages();
      });
      chip.appendChild(label);

      if (self.state.decorations.length > 1) {
        var x = document.createElement('button');
        x.type = 'button';
        x.className = 'ms-chip__x';
        x.setAttribute('aria-label', window.msStrings.removeDecoration || 'Kaldır');
        x.textContent = '✕';
        x.addEventListener('click', function (ev) {
          ev.stopPropagation();
          self.state.decorations.splice(i, 1);
          if (self.state.active >= self.state.decorations.length) {
            self.state.active = self.state.decorations.length - 1;
          }
          self.renderDecList();
          self.renderEditor();
          self.renderStages();
          self.renderTotals();
        });
        chip.appendChild(x);
      }

      box.appendChild(chip);
    });

    var add = document.createElement('button');
    add.type = 'button';
    add.className = 'ms-chip-add';
    add.textContent = window.msStrings.addDecoration || '+ Dekor ekle';
    add.addEventListener('click', function () {
      self.state.decorations.push(self.newDecoration());
      self.state.active = self.state.decorations.length - 1;
      self.renderDecList();
      self.renderEditor();
      self.renderStages();
      self.renderTotals();
    });
    box.appendChild(add);
  };

  MerchStudio.prototype.renderEditor = function () {
    var d = this.decoration();
    if (!d) return;

    $$('[data-ms-mode]').forEach(function (btn) {
      btn.classList.toggle('is-active', btn.getAttribute('data-ms-mode') === d.content);
    });
    $$('[data-ms-panel]').forEach(function (panel) {
      panel.classList.toggle('ms-hidden', panel.getAttribute('data-ms-panel') !== d.content);
    });

    var logoBox = $('[data-ms-logo-box]');
    if (logoBox) {
      logoBox.classList.toggle('has-file', !!d.logo);
      var logoText = $('[data-ms-logo-text]', logoBox);
      if (logoText) {
        logoText.textContent = d.logo
          ? ('✓ ' + d.logo.name)
          : (window.msStrings.uploadLogo || 'Logo yükle');
      }
    }

    var textInput = $('[data-ms-text-input]');
    if (textInput) textInput.value = d.text;

    this.renderPlacements();
    this.renderFonts();
    this.renderInks();
    this.renderDecorSizes();
  };

  /* --------------------------------------------------------------- adet */

  MerchStudio.prototype.renderQty = function () {
    var grid = $('[data-ms-qty-grid]');
    if (!grid) return;
    var self = this;
    var cfg = this.catalog.config;
    // Toplam stok MOQ'ya yetmiyorsa hiçbir kombinasyon geçerli olamaz; kutuları
    // doldurtup butonu sessizce kapalı tutmak yerine baştan kapatıyoruz.
    var unreachable = this.totalCap() < this.moq();
    grid.innerHTML = '';

    this.sizes().forEach(function (v) {
      var cell = document.createElement('div');
      cell.className = 'ms-qty';
      cell.setAttribute('data-ms-qty-cell', v.size);

      var label = document.createElement('span');
      label.className = 'ms-qty__size';
      label.textContent = v.size;
      cell.appendChild(label);

      var input = document.createElement('input');
      input.type = 'text';
      input.inputMode = 'numeric';
      input.autocomplete = 'off';
      input.className = 'ms-qty__input';
      input.value = self.state.qty[v.size] || '';
      input.setAttribute('aria-label', v.size);
      // Stok bilgisi placeholder'da baştan görünsün ki kullanıcı sınırı
      // hata alarak değil, yazmadan önce öğrensin. Sınır 0 ise "maks. 0" garip
      // okunuyor; o bedenin hiç satılamayacağını açıkça söylüyoruz.
      var capped = cfg.enforceStock && typeof v.cap === 'number';
      if (unreachable || (capped && v.cap <= 0)) {
        input.placeholder = window.msStrings.outOfStock || '—';
        input.disabled = true;
        cell.classList.add('is-empty');
      } else {
        input.placeholder = capped
          ? (window.msStrings.maxShort || 'maks.') + ' ' + v.cap
          : '0';
        if (!v.available && cfg.enforceStock) input.disabled = true;
      }

      input.addEventListener('input', function () {
        var n = parseInt(String(input.value).replace(/\D/g, ''), 10) || 0;
        self.state.qty[v.size] = n;
        input.value = n || '';
        self.renderQtyValidation();
        self.renderTotals();
      });

      cell.appendChild(input);

      var msg = document.createElement('span');
      msg.className = 'ms-qty__msg';
      msg.setAttribute('data-ms-qty-msg', v.size);
      cell.appendChild(msg);

      grid.appendChild(cell);
    });

    this.renderQtyValidation();
    this.renderTotals();
  };

  MerchStudio.prototype.renderQtyValidation = function () {
    var self = this;
    var cfg = this.catalog.config;

    this.sizes().forEach(function (v) {
      var cell = $('[data-ms-qty-cell="' + CSS.escape(v.size) + '"]');
      var msg = $('[data-ms-qty-msg="' + CSS.escape(v.size) + '"]');
      if (!cell || !msg) return;
      var n = self.state.qty[v.size] || 0;
      var over = cfg.enforceStock && typeof v.cap === 'number' && n > v.cap;
      cell.classList.toggle('is-error', over);
      msg.textContent = over
        ? (window.msStrings.maxStock || 'Bu beden için en fazla {n} adet').replace('{n}', v.cap)
        : '';
    });

    var total = this.totalUnits();
    var ladder = this.ladder() || {};
    var moq = this.moq();
    var qmax = ladder.max || cfg.qmax;

    var moqEl = $('[data-ms-moq]');
    if (moqEl) {
      // Merchant'ın yazdığı MOQ metnini sakla; stok mesajını gösterip geri alabilelim
      if (moqEl.getAttribute('data-ms-moq-default') === null) {
        moqEl.setAttribute('data-ms-moq-default', moqEl.textContent);
      }
      var cap = this.totalCap();
      if (cap < moq) {
        moqEl.textContent = (window.msStrings.stockBelowMoq ||
          'Bu renkte toplam {n} adet stok var; minimum sipariş {moq} adet.')
          .replace('{n}', cap).replace('{moq}', moq);
        moqEl.classList.add('is-warn');
      } else {
        moqEl.textContent = moqEl.getAttribute('data-ms-moq-default');
        moqEl.classList.toggle('is-warn', total > 0 && total < moq);
      }
    }

    var overMax = $('[data-ms-over-max]');
    if (overMax) overMax.classList.toggle('ms-hidden', total <= qmax);

    var ok = total >= moq && !this.overCapSizes().length;
    $$('[data-ms-go="quote"]').forEach(function (btn) {
      btn.disabled = !ok;
    });
  };

  MerchStudio.prototype.renderTotals = function () {
    var box = $('[data-ms-totals]');
    if (!box) return;
    var self = this;
    var q = this.quote();
    var p = this.product();
    box.innerHTML = '';

    var addRow = function (label, value, cls) {
      var el = document.createElement('div');
      el.className = 'ms-total__row' + (cls ? ' ' + cls : '');
      var l = document.createElement('span');
      l.textContent = label;
      var r = document.createElement('span');
      r.textContent = value;
      el.appendChild(l);
      el.appendChild(r);
      box.appendChild(el);
    };

    addRow(
      (window.msStrings.lineProduct || 'Ürün') + ' · ' + p.title + ' × ' + q.units,
      q.units ? money(q.total) : '—'
    );

    if (q.units && q.unitTry != null) {
      addRow(
        '↳ ' + (window.msStrings.lineUnit || 'birim') +
          ' (' + q.tierQty + ' ' + (window.msStrings.lineTier || 'adet kademesi') + ')',
        money(q.unitTry) + ' · ' + usdMoney(q.unitUsdGross) + '/' + (window.msStrings.unitShort || 'adet'),
        'ms-total__row--sub'
      );
    }

    if (this.state.perso) {
      this.state.decorations.forEach(function (d, i) {
        addRow(
          (window.msStrings.lineDecoration || 'Kişiselleştirme') + ' ' + (i + 1) + ' · ' + self.decLabel(d),
          window.msStrings.atQuote || 'Teklifte'
        );
      });
    }

    addRow(
      window.msStrings.lineGrand || 'Tahmini toplam (ürün)',
      money(q.total),
      'ms-total__row--grand'
    );
  };

  /**
   * Liquid'den gelen stok sayfa cache'inden geliyor ve bayat olabilir.
   * Adet adımına girerken canlı değeri çekip üst sınırları güncelliyoruz.
   */
  MerchStudio.prototype.refreshStock = function () {
    var p = this.product();
    if (!p || !this.catalog.config.enforceStock) return;
    if (this._stockChecked[p.handle]) return;
    this._stockChecked[p.handle] = true;

    var self = this;
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var url = root.replace(/\/$/, '') + '/products/' + p.handle + '.js';

    fetch(url, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        if (!data || !data.variants) return;
        var changed = false;
        data.variants.forEach(function (fresh) {
          for (var i = 0; i < p.variants.length; i++) {
            var v = p.variants[i];
            if (v.id !== fresh.id) continue;
            v.available = fresh.available;
            // inventory_quantity her mağaza yapılandırmasında dönmüyor; yoksa
            // Liquid'den gelen değeri koruyoruz
            if (typeof fresh.inventory_quantity === 'number' &&
                fresh.inventory_management &&
                fresh.inventory_policy !== 'continue') {
              v.cap = fresh.inventory_quantity;
              changed = true;
            }
            break;
          }
        });
        if (changed && self.state.view === 'quantity') self.renderQty();
      })
      .catch(function () { /* bayat veriyle devam — akışı bloklamıyoruz */ });
  };

  /* -------------------------------------------------------- sipariş özeti */

  MerchStudio.prototype.renderSummary = function () {
    var box = $('[data-ms-summary]');
    if (!box) return;
    var self = this;
    var q = this.quote();
    var p = this.product();
    box.innerHTML = '';

    var li = function (label, value) {
      var el = document.createElement('div');
      el.className = 'ms-summary__li';
      var l = document.createElement('span');
      l.textContent = label;
      var r = document.createElement('b');
      r.textContent = value;
      el.appendChild(l);
      el.appendChild(r);
      box.appendChild(el);
    };

    var S = window.msStrings;
    li(S.sumProduct || 'Ürün', p.title);
    li(S.sumColor || 'Renk', p.colorName);
    li(S.sumTotalQty || 'Toplam adet', String(q.units));
    li(S.sumUnitPrice || 'Birim fiyat', q.unitTry != null ? money(q.unitTry) : '—');

    this.sizes().forEach(function (v) {
      var n = self.state.qty[v.size] || 0;
      if (n) li(v.size, String(n));
    });

    if (this.state.perso) {
      this.state.decorations.forEach(function (d, i) {
        li((S.sumDecoration || 'Dekor') + ' ' + (i + 1), self.decLabel(d));
      });
      li(S.sumPersoPrice || 'Kişiselleştirme fiyatı', S.atQuote || 'Teklifte');
    } else {
      li(S.sumPerso || 'Kişiselleştirme', S.none || 'Yok');
    }

    li(S.lineGrand || 'Tahmini toplam (ürün)', money(q.total));
  };

  /* ------------------------------------------------------------- gönderim */

  MerchStudio.prototype.buildPayload = function (form, previews) {
    var self = this;
    var q = this.quote();
    var p = this.product();
    var cfg = this.catalog.config;
    var fd = new FormData(form);

    var sizes = [];
    this.sizes().forEach(function (v) {
      var n = self.state.qty[v.size] || 0;
      if (n > 0) sizes.push({ variantId: v.id, size: v.size, qty: n });
    });

    var decorations = this.state.perso ? this.state.decorations.map(function (d, i) {
      var found = self.areaById(d.placement);
      var sizeLabel = '';
      cfg.decorSizes.forEach(function (s) { if (s.id === d.size) sizeLabel = s.label; });
      var out = {
        index: i + 1,
        placement: d.placement,
        placementLabel: found ? found.area.label : d.placement,
        side: found ? found.side : 'front',
        size: sizeLabel,
        type: d.content
      };
      if (d.content === 'text') {
        var fontLabel = d.font;
        cfg.fonts.forEach(function (f) { if (f.id === d.font) fontLabel = f.label; });

        var inkId = d.ink || 'auto';
        var inkLabel = inkId;
        (cfg.inks || []).forEach(function (i) { if (i.id === inkId) inkLabel = i.label; });

        out.text = d.text;
        out.font = d.font;
        // Etiketler de gidiyor: id etiketten türetiliyor, merchant etiketi
        // değiştirdiğinde eski tekliflerdeki id hiçbir şeye eşleşmez olur.
        // Baskıyı yapan kişi "sans" değil "Sans" görmeli.
        out.fontLabel = fontLabel;
        out.ink = inkId;
        out.inkLabel = inkLabel;
        // Çözülmüş hex: "Otomatik" ürüne göre değiştiği için teklif anındaki
        // gerçek değer kayda geçmeli, sonradan yeniden hesaplanmamalı.
        out.inkHex = self.inkHexFor(d, self.product().colorHex);
      } else if (d.logo) {
        out.file = { name: d.logo.name, type: d.logo.type, bytes: d.logo.size };
        if (d.logo.size <= INLINE_UPLOAD_MAX) {
          out.file.dataUrl = d.logo.dataUrl;
        } else {
          // Büyük dosya payload'a gömülmüyor; satış ekibi e-posta ile isteyecek
          out.file.pending = true;
        }
      }
      return out;
    }) : [];

    return {
      source: 'merch-studio',
      clientRequestId: this.clientRequestId(),
      shop: window.Shopify ? window.Shopify.shop : '',
      locale: document.documentElement.lang || 'tr',
      customer: {
        id: window.msCustomerId || null,
        company: fd.get('company') || '',
        name: fd.get('name') || '',
        email: fd.get('email') || '',
        phone: fd.get('phone') || ''
      },
      note: fd.get('note') || '',
      product: {
        id: p.id,
        handle: p.handle,
        title: p.title,
        colorName: p.colorName,
        url: p.url,
        model: (this.catalog.shared || {}).modelName || null,
        // customization.lead_time metafield'ından — satış ekibi termini elle aramasın
        leadTime: cfg.leadTime || null
      },
      sizes: sizes,
      totalQty: q.units,
      pricing: {
        currency: 'TRY',
        fxRate: cfg.fx.rate,
        fxDate: cfg.fx.date,
        fxStale: cfg.fx.stale,
        ladderVersion: (this.ladder() || {}).version || null,
        unitUsd: q.unitUsd,
        unitTry: q.unitTry,
        productTotal: q.total
      },
      decorations: decorations,
      // Müşterinin gönderim anında gördüğü kompozisyon. Boş olabilir —
      // canvas'a çizilemediyse talep yine de gidiyor.
      previews: previews || [],
      // Turnstile token'ı widget'ın forma yazdığı gizli input'tan geliyor.
      // Doğrulama n8n'de secret key ile yapılıyor; secret asla temaya girmiyor.
      turnstileToken: fd.get('cf-turnstile-response') || null,
      // kvkk = Aydınlatma Metni okundu (merch-izinler).
      consent: { kvkk: !!fd.get('aydinlatma'), at: new Date().toISOString() },
      meta: {
        userAgent: navigator.userAgent,
        referrer: document.referrer || '',
        href: window.location.href,
        // Onayların kanıtı (metin + sürüm + kanal + zaman); n8n meta'yı
        // olduğu gibi kaydediyor.
        izin: window.MerchIzin ? window.MerchIzin.kayit(form, msTelefon(form)) : null
      }
    };
  };

  /* Formdaki kanonik telefon (ülke koduyla); boşsa ''. */
  function msTelefon(form) {
    var el = form && form.querySelector('[data-merch-phone]');
    if (!el) return '';
    return window.MerchPhone ? window.MerchPhone.deger(el) : String(el.value || '').trim();
  }

  /* --------------------------------------------------- önizleme yakalama */

  /*
   * Müşterinin teklif anında ekranda gördüğü kompozisyonu görüntüye çeviriyoruz.
   * Amaç kanıt: ileride "gönderdiğimiz buydu" diyebilmek. Ekrandaki önizleme DOM
   * katmanlarından oluşuyor, doğrudan görüntüye dönüşmüyor; bu yüzden aynı
   * geometriyi canvas'a yeniden çiziyoruz. paintArt ile birebir aynı formüller —
   * biri değişirse diğeri de değişmeli.
   */

  var PREVIEW_MAX_W = 900;
  var PREVIEW_QUALITY = 0.82;

  function loadImage(src, cors) {
    return new Promise(function (resolve, reject) {
      var img = new Image();
      // Shopify CDN'i ACAO:* gönderiyor; crossOrigin olmadan canvas "tainted"
      // olur ve toDataURL SecurityError atar.
      if (cors) img.crossOrigin = 'anonymous';
      img.onload = function () { resolve(img); };
      img.onerror = function () { reject(new Error('görsel yüklenemedi')); };
      img.src = src;
    });
  }

  function svgDataUri(svg) {
    // teeSvg satır içi kullanım için üretiliyor, xmlns'i yok; <img> kaynağı
    // olarak yüklenmesi için gerekiyor. Ölçü de verilmeli, yoksa bazı
    // tarayıcılarda naturalWidth 0 geliyor.
    var s = svg.replace('<svg ', '<svg xmlns="http://www.w3.org/2000/svg" width="360" height="360" ');
    return 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(s);
  }

  /** Tek yüzün önizlemesi. Dekorsuz yüzde null döner — düz ürün fotoğrafının kanıt değeri yok. */
  MerchStudio.prototype.renderPreview = function (side) {
    var self = this;
    var p = this.product();
    if (!p || !this.state.perso) return Promise.resolve(null);

    var cfg = this.catalog.config;
    var decs = this.state.decorations.filter(function (d) {
      var f = self.areaById(d.placement);
      if (!f || f.side !== side) return false;
      return (d.content === 'logo' && d.logo) || (d.content === 'text' && d.text);
    });
    if (!decs.length) return Promise.resolve(null);

    var src = p.mockups && p.mockups[side];
    var base = src ? loadImage(src, true) : loadImage(svgDataUri(teeSvg(side, p.colorHex)), false);

    return base.then(function (bg) {
      var natW = bg.naturalWidth || 360;
      var natH = bg.naturalHeight || 360;
      var W = Math.min(natW, PREVIEW_MAX_W);
      var H = Math.round(W * natH / natW);

      var canvas = document.createElement('canvas');
      canvas.width = W;
      canvas.height = H;
      var ctx = canvas.getContext('2d');

      // JPEG'in saydamlık kanalı yok; önce beyaz basmazsak saydam PNG ve
      // SVG şablon siyah çıkar.
      ctx.fillStyle = '#ffffff';
      ctx.fillRect(0, 0, W, H);
      ctx.drawImage(bg, 0, 0, W, H);

      var logos = decs.map(function (d) {
        return d.content === 'logo'
          ? loadImage(d.logo.dataUrl, false).catch(function () { return null; })
          : null;
      });

      return Promise.all(logos).then(function (imgs) {
        var off = p.printOffset || {};
        var oScale = typeof off.scale === 'number' ? off.scale : 1;
        var oDx = typeof off.dx === 'number' ? off.dx : 0;
        var oDy = typeof off.dy === 'number' ? off.dy : 0;

        decs.forEach(function (d, i) {
          var area = self.areaById(d.placement).area;
          var scale = 1;
          cfg.decorSizes.forEach(function (s) { if (s.id === d.size) scale = s.scale; });

          var cx = (0.5 + (area.x - 0.5) * oScale + oDx) * W;
          var cy = (0.5 + (area.y - 0.5) * oScale + oDy) * H;
          var bw = area.w * scale * oScale * W;

          if (d.content === 'logo' && imgs[i]) {
            var iw = imgs[i].naturalWidth || 1;
            var ih = imgs[i].naturalHeight || 1;
            // Baskı alanı KARE (kenar = bw) ve görsel içine sığdırılıyor.
            // Ekrandaki object-fit: contain ile aynı hesap — kanıt görseli
            // müşterinin gördüğünden farklı çıkarsa belge değerini yitirir.
            var oran = Math.min(bw / iw, bw / ih);
            var lw = iw * oran;
            var lh = ih * oran;
            ctx.drawImage(imgs[i], cx - lw / 2, cy - lh / 2, lw, lh);
          } else if (d.content === 'text' && d.text) {
            var font = cfg.fonts[0];
            cfg.fonts.forEach(function (f) { if (f.id === d.font) font = f; });
            // Ekrandakiyle aynı fonksiyon: boyut kutu genişliğiyle doğrusal,
            // dolayısıyla canvas ölçeğinde de aynı oran çıkıyor.
            var size = fitFontSize(d.text, font.family, font.weight, bw);
            if (!size) return;
            ctx.font = font.weight + ' ' + size + 'px ' + font.family;
            ctx.fillStyle = self.inkHexFor(d, p.colorHex);
            ctx.textAlign = 'center';
            ctx.textBaseline = 'middle';
            ctx.fillText(d.text, cx, cy);
          }
        });

        return {
          side: side,
          w: W,
          h: H,
          dataUrl: canvas.toDataURL('image/jpeg', PREVIEW_QUALITY)
        };
      });
    });
  };

  /** Dekor bulunan her yüzün önizlemesi. Hata talebi engellemez. */
  MerchStudio.prototype.capturePreviews = function () {
    var self = this;
    if (!this.state.perso) return Promise.resolve([]);

    var sides = this.hasBackView() ? ['front', 'back'] : ['front'];
    return Promise.all(sides.map(function (s) {
      return self.renderPreview(s).catch(function (err) {
        // Önizleme kanıt amaçlı ek bilgi. Alınamazsa talep yine de gitmeli;
        // müşteriyi teknik bir aksaklık yüzünden geri çevirmek daha kötü.
        console.warn('[merch-studio] önizleme alınamadı (' + s + ')', err);
        return null;
      });
    })).then(function (list) {
      return list.filter(Boolean);
    });
  };

  /** Ağ koptuğunda tekrar denense de tek talep açılsın diye sabit kimlik */
  MerchStudio.prototype.clientRequestId = function () {
    if (!this._clientRequestId) {
      this._clientRequestId = (window.crypto && window.crypto.randomUUID)
        ? window.crypto.randomUUID()
        : 'ms-' + Date.now() + '-' + Math.random().toString(36).slice(2);
    }
    return this._clientRequestId;
  };

  MerchStudio.prototype.submit = function (form) {
    var self = this;
    var cfg = this.catalog.config;
    var errBox = $('[data-ms-form-error]');
    var btn = $('[data-ms-submit]', form);

    if (this.state.submitting) return;

    // Onaylar (aydınlatma zorunlu, ticari ileti isteğe bağlı): merch-izin.js
    // hatayı kutunun altına yazıp odaklanıyor. Betik yüklenmediyse en
    // azından aydınlatma kutusu aranıyor.
    if (window.MerchIzin) {
      if (!window.MerchIzin.dogrula(form, msTelefon(form))) return;
    } else if (!new FormData(form).get('aydinlatma')) {
      return;
    }

    // Turnstile yapılandırılmışsa token gelmeden göndermiyoruz: aksi halde n8n
    // her seferinde reddeder ve kullanıcı sebebini anlamaz.
    if (cfg.turnstile) {
      var tsField = form.querySelector('[name="cf-turnstile-response"]');
      if (!tsField || !tsField.value) {
        if (errBox) {
          errBox.textContent = window.msStrings.turnstilePending ||
            'Güvenlik doğrulaması tamamlanmadı, birkaç saniye bekleyip tekrar deneyin.';
          errBox.classList.remove('ms-hidden');
        }
        return;
      }
    }

    if (!cfg.quoteWebhook) {
      if (errBox) {
        errBox.textContent = window.msStrings.noWebhook ||
          'Teklif ucu tanımlı değil. Tema ayarlarından Merch Studio webhook adresini girin.';
        errBox.classList.remove('ms-hidden');
      }
      console.error('[merch-studio] settings.merch_quote_webhook boş');
      return;
    }

    this.state.submitting = true;
    if (btn) btn.disabled = true;
    if (errBox) errBox.classList.add('ms-hidden');
    form.classList.add('is-submitting');

    // Önizlemeyi göndermeden ÖNCE alıyoruz: onay ekranına geçtikten sonra
    // sahne yeniden çizilmiş oluyor ve o an gördüğü kompozisyon kaybolur.
    this.capturePreviews()
      .then(function (previews) {
        return fetch(cfg.quoteWebhook, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(self.buildPayload(form, previews))
        });
      })
      .then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.json().catch(function () { return {}; });
      })
      .then(function (data) {
        self.state.requestNo = data.requestNo || null;
        var refEl = $('[data-ms-request-no]');
        if (refEl) {
          refEl.textContent = self.state.requestNo ||
            (window.msStrings.requestNoPending || 'E-posta ile iletilecek');
        }
        self.go('done');
      })
      .catch(function (err) {
        console.error('[merch-studio] teklif gönderilemedi', err);
        if (errBox) {
          errBox.textContent = window.msStrings.submitError ||
            'Talebinizi gönderemedik. Lütfen tekrar deneyin.';
          errBox.classList.remove('ms-hidden');
        }
        // Turnstile token'ı tek kullanımlık ve ~5 dk'da bayatlıyor. Sıfırlamazsak
        // ikinci deneme her zaman doğrulamada takılır.
        if (window.turnstile && typeof window.turnstile.reset === 'function') {
          try { window.turnstile.reset(); } catch (e) { /* widget yoksa önemsiz */ }
        }
      })
      .then(function () {
        self.state.submitting = false;
        if (btn) btn.disabled = false;
        form.classList.remove('is-submitting');
      });
  };

  MerchStudio.prototype.restart = function () {
    this.state.perso = false;
    this.state.side = 'front';
    this.state.decorations = [this.newDecoration()];
    this.state.active = 0;
    this.state.qty = {};
    this.state.requestNo = null;
    this._clientRequestId = null;

    var toggle = $('[data-ms-perso-toggle]');
    if (toggle) toggle.checked = false;
    var body = $('[data-ms-perso-body]');
    if (body) body.classList.add('ms-hidden');
    var form = $('[data-ms-quote-form]');
    if (form) form.reset();

    this.renderAll();
    this.go('design');
  };

  /* ------------------------------------------------------------- bağlama */

  MerchStudio.prototype.bind = function () {
    var self = this;

    document.addEventListener('click', function (ev) {
      var goBtn = ev.target.closest('[data-ms-go]');
      if (goBtn) {
        ev.preventDefault();
        self.go(goBtn.getAttribute('data-ms-go'));
        return;
      }

      var sideBtn = ev.target.closest('[data-ms-side]');
      if (sideBtn) {
        ev.preventDefault();
        self.state.side = sideBtn.getAttribute('data-ms-side');
        self.renderStages();
        return;
      }

      var modeBtn = ev.target.closest('[data-ms-mode]');
      if (modeBtn) {
        ev.preventDefault();
        var d = self.decoration();
        if (d) {
          d.content = modeBtn.getAttribute('data-ms-mode');
          self.renderEditor();
          self.renderDecList();
          self.renderStages();
        }
        return;
      }

      if (ev.target.closest('[data-ms-restart]')) {
        ev.preventDefault();
        self.restart();
      }
    });

    var toggle = $('[data-ms-perso-toggle]');
    if (toggle) {
      toggle.addEventListener('change', function () {
        self.state.perso = toggle.checked;
        var body = $('[data-ms-perso-body]');
        if (body) body.classList.toggle('ms-hidden', !self.state.perso);
        self.renderStages();
        self.renderTotals();
      });
    }

    var textInput = $('[data-ms-text-input]');
    if (textInput) {
      textInput.addEventListener('input', function () {
        var d = self.decoration();
        if (!d) return;
        d.text = textInput.value;
        self.renderDecList();
        self.renderStages();
        self.renderTotals();
      });
    }

    var logoInput = $('[data-ms-logo-input]');
    if (logoInput) {
      logoInput.addEventListener('change', function (ev) {
        var file = ev.target.files && ev.target.files[0];
        if (!file) return;
        var d = self.decoration();
        if (!d) return;

        var reader = new FileReader();
        reader.onload = function (e) {
          d.logo = {
            name: file.name,
            type: file.type,
            size: file.size,
            dataUrl: e.target.result
          };
          d.content = 'logo';
          self.renderEditor();
          self.renderDecList();
          self.renderStages();
          self.renderTotals();
        };
        reader.readAsDataURL(file);
      });
    }

    var form = $('[data-ms-quote-form]');
    if (form) {
      form.addEventListener('submit', function (ev) {
        ev.preventDefault();
        // Honeypot: bot doldurursa sessizce başarı taklidi yapıp hiçbir şey göndermiyoruz
        if (form.querySelector('[name="ms_website"]') &&
            form.querySelector('[name="ms_website"]').value) {
          self.go('done');
          return;
        }
        self.submit(form);
      });
    }

    // Baskı alanı koordinatları oransal; yazı boyutu piksel cinsinden hesaplandığı
    // için sahne yeniden boyutlandığında tekrar çizmek gerekiyor.
    if (window.ResizeObserver) {
      var ro = new ResizeObserver(function () { self.renderStages(); });
      $$('[data-ms-stage]').forEach(function (stage) { ro.observe(stage); });
    } else {
      window.addEventListener('resize', function () { self.renderStages(); });
    }
  };

  /* ------------------------------------------------------------ başlatma */

  var instance = null;

  function boot() {
    instance = new MerchStudio();
    if (!instance.init()) instance = null;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Theme editor tek section'ı yeniden render ediyor; kontrolcüyü yeniden bağla
  document.addEventListener('shopify:section:load', function (ev) {
    if (!ev.target.querySelector('[data-ms-view]') && !ev.target.hasAttribute('data-ms-view')) return;
    boot();
  });

  // Gizli bir adım section'ı seçildiğinde o görünüme geç, yoksa merchant
  // düzenlemeye çalıştığı section'ı hiç göremiyor
  document.addEventListener('shopify:section:select', function (ev) {
    if (!instance) return;
    var host = ev.target.hasAttribute('data-ms-view')
      ? ev.target
      : ev.target.querySelector('[data-ms-view]');
    if (!host) return;
    var views = host.getAttribute('data-ms-view').split(/\s+/);
    if (views.indexOf(instance.state.view) === -1) instance.go(views[0], { scroll: false });
  });

  window.MerchStudio = MerchStudio;

  /* ==================================================== talep sorgulama ====
     Kendi sayfasında, konfigüratörden bağımsız çalışır: katalog verisi yok,
     MerchStudio.init() orada zaten false döner. Bu yüzden ayrı bir modül.
     ======================================================================== */

  function bootLookup() {
    var form = $('[data-ms-lookup-form]');
    if (!form || form.hasAttribute('data-ms-bound')) return;
    form.setAttribute('data-ms-bound', '');

    var errBox = $('[data-ms-lookup-error]');
    var sentBox = $('[data-ms-lookup-sent]');
    var resultBox = $('[data-ms-lookup-result]');
    var btn = $('[data-ms-lookup-submit]', form);
    var step2 = $('[data-ms-lookup-step2]');
    var codeInput = step2 ? $('input', step2) : null;
    var resendBtn = $('[data-ms-lookup-resend]');
    var S = window.msLookupStrings || {};
    var busy = false;

    // 'ask' = talep no + e-posta girilip kod isteniyor
    // 'verify' = kod bekleniyor
    var stage = 'ask';

    var fail = function (message) {
      if (resultBox) resultBox.classList.add('ms-hidden');
      if (sentBox) sentBox.classList.add('ms-hidden');
      if (errBox) {
        errBox.textContent = message;
        errBox.classList.remove('ms-hidden');
      }
    };

    /*
     * 2. adıma geç. Kod alanı DOM'da baştan var ama `disabled`: gizli bir
     * required alan tarayıcının form doğrulamasını sessizce kilitlerdi.
     */
    var toVerify = function () {
      stage = 'verify';
      if (step2) step2.classList.remove('ms-hidden');
      if (codeInput) {
        codeInput.disabled = false;
        codeInput.required = true;
        codeInput.value = '';
        codeInput.focus();
      }
      if (resendBtn) resendBtn.classList.remove('ms-hidden');
      if (btn) btn.textContent = btn.getAttribute('data-label-step2') || btn.textContent;
      if (errBox) errBox.classList.add('ms-hidden');
      if (sentBox) {
        sentBox.textContent = S.codeSent ||
          'Kodu e-posta adresinize gönderdik. 10 dakika geçerli.';
        sentBox.classList.remove('ms-hidden');
      }
    };

    /*
     * Kod iste. Yanıt talebin var olup olmadığından bağımsız olarak hep aynı;
     * bu yüzden burada da ayrım yapmadan 2. adıma geçiyoruz. Aksi hâlde
     * "numara yok" bilgisi ekrandan sızar ve numara taraması mümkün olurdu.
     */
    var requestCode = function (payload) {
      if (!window.msCodeWebhook) {
        fail(S.codeError || 'Doğrulama kodu ucu tanımlı değil.');
        console.error('[merch-studio] settings.merch_code_webhook boş');
        return Promise.resolve(false);
      }
      return fetch(window.msCodeWebhook, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      }).then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return true;
      });
    };

    var row = function (label, value) {
      var el = document.createElement('div');
      el.className = 'ms-summary__li';
      var l = document.createElement('span');
      l.textContent = label;
      var r = document.createElement('b');
      r.textContent = value;
      el.appendChild(l);
      el.appendChild(r);
      return el;
    };

    form.addEventListener('submit', function (ev) {
      ev.preventDefault();
      if (busy) return;

      var fd = new FormData(form);
      if (fd.get('ms_website')) return; // honeypot: bot doldurmuş, sessizce yut

      var creds = {
        requestNo: String(fd.get('requestNo') || '').trim(),
        email: String(fd.get('email') || '').trim()
      };

      busy = true;
      if (btn) btn.disabled = true;
      if (errBox) errBox.classList.add('ms-hidden');
      if (resultBox) resultBox.classList.add('ms-hidden');

      // 1. adım: kodu iste, sonuca bakmadan 2. adıma geç
      if (stage === 'ask') {
        requestCode(creds)
          .then(function (ok) { if (ok) toVerify(); })
          .catch(function (err) {
            console.error('[merch-studio] kod istenemedi', err);
            fail(S.codeError || 'Doğrulama kodu gönderilemedi. Lütfen tekrar deneyin.');
          })
          .then(function () {
            busy = false;
            if (btn) btn.disabled = false;
          });
        return;
      }

      var code = String(fd.get('code') || '').replace(/\D/g, '');
      if (code.length !== 6) {
        fail(S.codeMissing || 'E-postanıza gelen 6 haneli kodu girin.');
        busy = false;
        if (btn) btn.disabled = false;
        return;
      }

      fetch(window.msLookupWebhook, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          requestNo: creds.requestNo,
          email: creds.email,
          code: code
        })
      })
        .then(function (r) {
          if (!r.ok) throw new Error('HTTP ' + r.status);
          return r.json();
        })
        .then(function (data) {
          // Eşleşme yoksa her zaman AYNI jenerik mesaj: "bu numara var ama e-posta
          // yanlış" demek talep no taramaya davetiye olurdu.
          if (!data || data.found !== true) {
            fail(S.notFound || 'Talep bulunamadı. Numarayı ve e-postayı kontrol edin.');
            return;
          }

          resultBox.innerHTML = '';

          var card = document.createElement('div');
          card.className = 'ms-summary';
          var head = document.createElement('h3');
          head.className = 'ms-summary__title';
          head.textContent = data.requestNo || '';
          card.appendChild(head);

          if (data.statusLabel) card.appendChild(row(S.labelStatus || 'Durum', data.statusLabel));
          if (data.createdAt) {
            var d = new Date(data.createdAt);
            card.appendChild(row(
              S.labelCreated || 'Oluşturulma',
              isNaN(d) ? data.createdAt : d.toLocaleDateString('tr-TR')
            ));
          }
          if (data.product) card.appendChild(row(S.labelProduct || 'Ürün', data.product));
          if (data.totalQty) card.appendChild(row(S.labelQty || 'Toplam adet', String(data.totalQty)));
          if (typeof data.estimatedTotal === 'number') {
            card.appendChild(row(S.labelTotal || 'Tahmini toplam', money(data.estimatedTotal)));
          }
          resultBox.appendChild(card);

          /*
           * Müşterinin gönderim anında gördüğü kompozisyon. Kendi tarafında da
           * görmesi "gönderdiğim bu muydu" sorusunu baştan kapatıyor.
           * Görseller data URI olarak geliyor — ek istek yok.
           */
          if (Array.isArray(data.previews) && data.previews.length) {
            var pWrap = document.createElement('div');
            pWrap.className = 'ms-lookup__previews';

            var pTitle = document.createElement('h4');
            pTitle.className = 'ms-mini-label';
            pTitle.textContent = S.previewTitle || 'Gönderdiğiniz tasarım';
            pWrap.appendChild(pTitle);

            var pGrid = document.createElement('div');
            pGrid.className = 'ms-lookup__preview-grid';
            data.previews.forEach(function (p) {
              var fig = document.createElement('figure');
              fig.className = 'ms-lookup__preview';
              var img = document.createElement('img');
              img.src = p.src;
              img.alt = p.label || '';
              img.loading = 'lazy';
              fig.appendChild(img);
              if (p.label) {
                var cap = document.createElement('figcaption');
                cap.textContent = p.label;
                fig.appendChild(cap);
              }
              pGrid.appendChild(fig);
            });
            pWrap.appendChild(pGrid);
            resultBox.appendChild(pWrap);
          }

          // Zaman çizelgesi tamamen backend'den geliyor; tema adım isimlerini
          // bilmiyor, böylece n8n'de yeni durum eklemek tema değişikliği istemiyor.
          if (Array.isArray(data.timeline) && data.timeline.length) {
            var tl = document.createElement('ol');
            tl.className = 'ms-timeline';
            data.timeline.forEach(function (step) {
              var li = document.createElement('li');
              li.className = 'ms-timeline__step' + (step.done ? ' is-done' : '');
              var label = document.createElement('span');
              label.textContent = step.label || step.status || '';
              li.appendChild(label);
              if (step.at) {
                var when = new Date(step.at);
                var t = document.createElement('time');
                t.textContent = isNaN(when) ? step.at : when.toLocaleDateString('tr-TR');
                li.appendChild(t);
              }
              tl.appendChild(li);
            });
            resultBox.appendChild(tl);
          }

          if (data.note) {
            var note = document.createElement('p');
            note.className = 'ms-note';
            note.textContent = data.note;
            resultBox.appendChild(note);
          }

          if (sentBox) sentBox.classList.add('ms-hidden');
          resultBox.classList.remove('ms-hidden');
        })
        .catch(function (err) {
          console.error('[merch-studio] sorgulama başarısız', err);
          fail(S.error || 'Sorgulama yapılamadı. Lütfen tekrar deneyin.');
        })
        .then(function () {
          busy = false;
          if (btn) btn.disabled = false;
        });
    });

    if (resendBtn) {
      resendBtn.addEventListener('click', function () {
        if (busy) return;
        var fd = new FormData(form);
        busy = true;
        resendBtn.disabled = true;
        requestCode({
          requestNo: String(fd.get('requestNo') || '').trim(),
          email: String(fd.get('email') || '').trim()
        })
          .then(function (ok) {
            if (ok && sentBox) {
              sentBox.textContent = S.codeSent ||
                'Kodu e-posta adresinize gönderdik. 10 dakika geçerli.';
              sentBox.classList.remove('ms-hidden');
              if (errBox) errBox.classList.add('ms-hidden');
            }
            // Yeni kod öncekini geçersiz kılıyor; eskisi kutuda kalmasın
            if (codeInput) { codeInput.value = ''; codeInput.focus(); }
          })
          .catch(function (err) {
            console.error('[merch-studio] kod tekrar gönderilemedi', err);
            fail(S.codeError || 'Doğrulama kodu gönderilemedi. Lütfen tekrar deneyin.');
          })
          .then(function () {
            busy = false;
            resendBtn.disabled = false;
          });
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootLookup);
  } else {
    bootLookup();
  }
  document.addEventListener('shopify:section:load', bootLookup);
})();
